// =============================================================================
// MyDayBlock — operativa del día del usuario
// 7 KPIs con drill-down a los listados correspondientes
// =============================================================================

import type { MyDay } from '../../types/dashboard';
import { KpiCard } from './KpiCard';

interface MyDayBlockProps {
  data: MyDay | null;
  loading: boolean;
}

export function MyDayBlock({ data, loading }: MyDayBlockProps) {
  return (
    <section>
      <header className="flex items-center gap-2 mb-3">
        <span className="material-symbols-outlined text-primary">today</span>
        <h2 className="text-base font-semibold text-slate-900">Mi día</h2>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        <KpiCard
          icon="notifications_active"
          label="Recordatorios de hoy"
          value={data?.pendingRemindersToday ?? 0}
          tone="primary"
          to="/recordatorios?estado=PENDIENTE&fecha=hoy"
          loading={loading}
        />
        <KpiCard
          icon="error"
          label="Fallidos sin gestionar"
          value={data?.failedRemindersUnhandled ?? 0}
          tone={(data?.failedRemindersUnhandled ?? 0) > 0 ? 'red' : 'slate'}
          to="/recordatorios?estado=FALLIDO"
          loading={loading}
        />
        <KpiCard
          icon="edit_note"
          label="Mis borradores"
          value={data?.myDrafts ?? 0}
          tone="amber"
          to="/presupuestos?estado=BORRADOR&mios=true"
          loading={loading}
        />
        <KpiCard
          icon="schedule_send"
          label="Enviados sin respuesta >7d"
          value={data?.sentAwaitingOver7d ?? 0}
          tone={(data?.sentAwaitingOver7d ?? 0) > 0 ? 'amber' : 'slate'}
          to="/seguimiento-presupuestos"
          loading={loading}
        />
        <KpiCard
          icon="payments"
          label="Aceptados con deuda"
          value={data?.acceptedWithDebt ?? 0}
          tone={(data?.acceptedWithDebt ?? 0) > 0 ? 'amber' : 'slate'}
          to="/presupuestos?estado=ACEPTADO&deuda=true"
          loading={loading}
        />
        <KpiCard
          icon="call"
          label="Contactos programados hoy"
          value={data?.scheduledContactsToday ?? 0}
          tone="primary"
          to="/seguimiento-presupuestos?programados=hoy"
          loading={loading}
        />
        <KpiCard
          icon="phone_missed"
          label="Contactos caducados"
          value={data?.overdueScheduledContacts ?? 0}
          tone={(data?.overdueScheduledContacts ?? 0) > 0 ? 'red' : 'slate'}
          to="/seguimiento-presupuestos?programados=caducados"
          loading={loading}
        />
      </div>
    </section>
  );
}
